// extracted by mini-css-extract-plugin
export default {"tab-container":"app-performanceReviews-PerformanceReviewSingle-AssociatedRecordTabs-module__YV2sCKC38Zr9K9NEiGBM"};